        
import React, { Component } from "react";
import UserIcon from "../../assets/icons8-user-activity-50.png";
import urls from "../../custom_libraries/urls";
import {get, getFreshToken} from "../../custom_libraries/serverRequests";
import { Button} from '@mui/material';

class UserActivityLogs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      logs: [],
      user: "",
      loading: true,
      error: "",
      next: null, // URL for the next page
      previous: null, // URL for the previous page
      filteredLogs: [],
      fromDate: '',
      toDate:'',
      selectedModel:'',
      // selectedChangeType
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.validateSignedIn();
    }, 0);
    this.fetchActivityLogs();
  }

  validateSignedIn = async () => {
      try {
        let is_fresh_token = await getFreshToken();
        console.log("Fresh Token:", is_fresh_token);
    
        if (!is_fresh_token) {
          console.log("Navigating to login...");
          this.props.navigate("/");
          return;
        }
      } catch (error) {
        console.error("Error in validateSignedIn:", error);
      }
    }

  fetchActivityLogs = async () => {
    try {
      const { fromDate, toDate, selectedModel } = this.state;

      let data = {
        "start_date":fromDate || '',
        "end_date": toDate || '',
        "model": selectedModel || '',
      }

      data = JSON.stringify(data);

      console.log("----data to fetch activity log----", data);

      // Construct the URL with query parameters
    const url = urls.GET_ALL_USERS_ACTIVITY_LOGS(selectedModel || '', fromDate || '', toDate || '');

    console.log("----URL to fetch activity log----", url);

    let response = await get(url);
    console.log("------Activity Logs Response--------", response);

      // let response = await get(urls.GET_ALL_USERS_ACTIVITY_LOGS, data)
      console.log("------activity res--------", response);

      this.setState({
        user: response.results.user,
        logs: response.results.activity_logs,
        loading: false,
        next: response.next || null, // Explicitly handle next
        previous: response.previous || null, // Explicitly handle previous
        filteredLogs: response.results.activity_logs,
      });
    } catch (err) {
      this.setState({
        error: "Failed to fetch activity logs. Please try again.",
        loading: false,
      });
    }
  };

  fetchNextActivityLogs = async (url) => {
    console.log("fetchNextActivityLogs called with URL:", url);
    try {
        let response = await get(url);
        console.log("------activity res--------", response);
        const { next, previous } = response;
        this.setState({
            logs: response.results.activity_logs,
            next,
            previous,
            user: response.results.user,
            loading: false,
            filteredLogs: response.results.activity_logs,
        });
    } catch (err) {
        this.setState({
            error: "Failed to fetch activity logs. Please try again.",
            loading: false,
        });
    }
};

  handleNext = () => {
    const { next } = this.state;
    if (next) {
        this.fetchNextActivityLogs(next);
    }
};

handlePrevious = () => {
    const { previous } = this.state;
    if (previous) {
        this.fetchNextActivityLogs(previous);
    }
};

handleFilterChange = (event) => {
  this.setState({ filterType: event.target.value, filteredLogs: this.state.logs, fromDate: "", toDate: "", selectedModel: "" });
};

handleApplyFilter = () => {
  const { filterType, logs, fromDate, toDate, selectedModel } = this.state;
  let filtered = logs;

  if (filterType === "date") {
    filtered = logs.filter(log => {
      const logDate = new Date(log.timestamp);
      return logDate >= new Date(fromDate) && logDate <= new Date(toDate);
    });
  } else if (filterType === "model") {
    filtered = logs.filter(log => log.model === selectedModel);
  } 
  // else if (filterType === "change_type") {
  //   filtered = logs.filter(log => log.change_type === selectedChangeType);
  // }

  this.setState({ filteredLogs: filtered });
};

ClearFilter = () => {
  this.setState(
    { filterType: "", fromDate: "", toDate: "", selectedModel: "" },
    () => {
      this.fetchActivityLogs(); // Ensure this runs after state update
    }
  );
}

  render() {
    // const { logs, user, loading, error, previous, next } = this.state;

    const { filteredLogs, user, loading, error, previous, next, filterType, fromDate, toDate, selectedModel, selectedChangeType, logs } = this.state;

    // const uniqueChangeTypes = [...new Set(logs.map(log => log.change_type))];

    if (loading) return <p style={{marginLeft:'1cm'}}>Loading...</p>;

    return (
      <div style={{height: "100vh", marginLeft:'5%', paddingRight:'10px'}}>
        <div>
          {/* <h2> Activity </h2> */}
          {error && <p style={{ color: "red" }}>{error}</p>}
          
           {/* Filter Selection */}
           <div style={{display:'flex', justifyContent:'space-between'}}>
            <p className="activityDealer">Admin User: {user}</p>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <label style={{fontSize:'14px', whiteSpace: 'nowrap', color: '#4a5686'}}><b> Filter by: </b></label>
              <select value={filterType} onChange={this.handleFilterChange}>
                <option value="">Select Filter</option>
                <option value="date">Date Wise</option>
                <option value="model">Model Wise</option>
              </select>
            </div>
           </div>
        <div style={{ marginBottom: "15px", display: 'flex', alignItems: 'center', gap: '15px' }}>

          {/* Date Range Filter */}
          {filterType === "date" && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <label style={{fontSize:'14px', color: '#4a5686'}}>From: </label>
              <input type="date" value={fromDate} onChange={(e) => this.setState({ fromDate: e.target.value })} />
              <label style={{fontSize:'14px', color: '#4a5686'}}>To: </label>
              <input type="date" value={toDate} min={this.state.fromDate}  onChange={(e) => this.setState({ toDate: e.target.value })} />
            </div>
          )}

          {/* Model Wise Filter */}
          {filterType === "model" && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <label style={{fontSize:'14px', color: '#4a5686'}}>Model: </label>
              <select value={selectedModel} onChange={(e) => this.setState({ selectedModel: e.target.value })}>
                <option value="">Select Model</option>
                <option value="Device">Device</option>
                <option value="SiteDb">Site</option>
                <option value="NotificationSettings">Notifications</option>
              </select>
            </div>
          )}

          {filterType && (
            <>
            <Button onClick={this.fetchActivityLogs} 
            id="rowsPerPageButton" 
            style={{fontSize:'12px', fontWeight:'bold', height: "34px", display: "flex", alignItems: "center"}}>
            Apply
          </Button>
            <Button 
            id="clearUserLogButton" 
            style={{fontSize:'12px', fontWeight:'bold', height: "34px", display: "flex", alignItems: "center"}}
            // onClick={() => this.setState({ filterType: "", fromDate: "", toDate: "", selectedModel: "" })}
            onClick={this.ClearFilter}
            >
            clear
          </Button>
          </>
          )}
          
        </div>

          {/* Logs List */}
          <div className="logs-list">
            {logs.length > 0 ? (
              logs.map((log, index) => (
                <div style={{display:'flex', alignItems: 'flex-start', gap: '10px', marginTop:'15px'}}>
                <img src={UserIcon} alt="user-icon" width="23px" />
                <p key={index} style={{ margin: 0 }} >
                    <span className="activityTime" >{`${new Date(log.timestamp).toLocaleString()}.`}</span>
                    {/* <span className="activityDescription" > {`${log.change_type} ${log.model === "SiteDb" ? log.sitename :  log.model === "NotificationSettings" ? log.model : log.name} `}</span><br/> */}
                    <span className="activityDescription" > {`${log.change_type} ${log.model}`}</span><br/>

                    <span className="activitySubDesc">
                    {`${log.model} : ${
                        log.model === "SiteDb"
                            ? log.sitename
                            : log.model === "NotificationSettings"
                            ? log.model
                            : log.name
                    }`}                      </span><br/>
                    <span className="activityUser" >{`${log.user}`}</span>
                </p>
                </div>
              ))
            ) : (
              <p style={{color:'orange'}}>No activity logs available.</p>
            )}
          </div>
        </div>
        <div style={{ marginTop: '0.5cm', marginBottom:'0.5cm', display: 'flex', justifyContent: 'center', alignItems:'baseline' }}>
            <Button
              id="rowsPerPageButton"
              onClick={this.handlePrevious}
              disabled={!previous}
              variant="contained"
            >
              {"< Prev"}
            </Button>

            <Button
              id="rowsPerPageButton"
              onClick={this.handleNext}
              disabled={!next}
              variant="contained"
            >
              {"Next >"}
            </Button>
        </div>
        </div>
    );
  }
}

export default UserActivityLogs;
